var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 97,
    viewBox: "0 0 110 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9476 26.6256L82.477 16.1972L83.11 11.8081C65.7473 -5.47375 38.1448 -3.51183 22.488 15.8958C18.1388 21.2845 14.9156 28.0058 13.1953 34.9492L16.607 34.4203L35.6658 30.983L37.1349 29.3384C45.6108 19.1481 59.9485 17.7784 69.734 26.4458L72.9476 26.6256Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0715 34.6779C93.8824 25.8519 89.3835 17.9143 83.1304 11.8435L69.7544 26.4812C75.4034 31.5314 78.6169 39.1358 78.4816 47.1157V49.7122C85.0537 49.7122 90.3838 55.5451 90.3838 62.737C90.3838 69.929 85.0537 75.6191 78.4816 75.6191H54.6436L52.3047 78.4007V94.0273L54.6436 96.481H78.4816C95.5786 96.629 109.549 81.7216 109.684 63.012C109.766 51.6689 104.654 41.0343 96.0715 34.6779Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8322 96.4402H54.6413V75.5836H30.8322C29.1457 75.5836 27.4834 75.1817 25.9515 74.4149L22.5737 75.5466L12.9766 85.9749L12.1406 89.5233C17.5239 93.9706 24.0911 96.472 30.8322 96.4402Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8248 28.7832C13.723 28.8942 -0.0540477 44.1559 0.047432 62.8708C0.10542 73.3203 4.5657 83.1563 12.1332 89.5286L25.9441 74.4149C19.952 71.4536 17.2893 63.7381 19.9954 57.1807C22.7016 50.6234 29.752 47.7096 35.7441 50.671C38.3826 51.9772 40.4992 54.2881 41.6928 57.1807L55.5037 42.0671C49.6275 33.6589 40.4944 28.7461 30.8248 28.7832Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.33250a5698f48defcd137fd57820b378.svg";
export { ForwardRef as ReactComponent };